"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useAppHeight = void 0;
var useAppHeight_1 = require("./useAppHeight");
Object.defineProperty(exports, "useAppHeight", { enumerable: true, get: function () { return useAppHeight_1.useAppHeight; } });
